import { createFileRoute } from "@tanstack/react-router";

import { DashboardSkeleton } from "@/components/shared";
import { Error } from "@/pages/Error/Error";
import { SectionDashboardPage } from "@/pages/Section";

export const Route = createFileRoute("/app/companies/$company_id/sections/$section_id/dashboard")({
  component: SectionDashboardPage,
  pendingComponent: () => <DashboardSkeleton title="Loading dashboard..." />,
  errorComponent: ({ error, reset }) => (
    <Error
      error={error}
      reset={reset}
    />
  ),
});
